module.exports = __webpack_public_path__ + "static/media/light.cbb4b305.svg";